import { useRolodexEdit } from 'features/fde/rolodexAPI'
import { useMapVizCameraContext } from 'features/siteMap/contexts/MapVizCameraContext'
import { useSiteModelContext } from 'features/siteMap/contexts/SiteModelContext'
import React, { FC } from 'react'
import styled from 'styled-components'

const SetCameraOrientationButton = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  font-family: sans-serif;
  width: fit-content;
  padding: 4px 8px;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`

export const SetCameraOrientation: FC = () => {
  const { rolodexPatch } = useRolodexEdit()
  const { camera } = useMapVizCameraContext()
  const { siteModel, setSiteModel } = useSiteModelContext()

  return (
    <SetCameraOrientationButton
      onClick={() => {
        if (!camera || !camera.current) return
        const cameraOrigin = {
          position: [
            camera.current.position.x,
            camera.current.position.y,
            camera.current.position.z,
          ] as [number, number, number],
          rotation: [
            camera.current.rotation.x,
            camera.current.rotation.y,
            camera.current.rotation.z,
          ] as [number, number, number],
        }
        rolodexPatch([
          {
            id: siteModel.id,
            data: {
              camera_origin: cameraOrigin,
            },
          },
        ])
        const newSiteModel = {
          ...siteModel,
        }
        newSiteModel.data.camera_origin = cameraOrigin
        setSiteModel(newSiteModel)
      }}>
      Set Current View as Camera Origin
    </SetCameraOrientationButton>
  )
}
